import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
import { useTheme } from '../../../context/ThemeContext';
import logoApp from '../../../assets/logos/logo_swift_ride_green.png';
import { fetchListItems } from '../../../hooks/useCrud';
import GoogleTranslate from '../../../components/GoogleTranslate';
import VideoPub from '../Components/Sections/about/VideoPub';
import { baseURL, fileUrl } from '../../../api/config';
import ActualiteMenu from './components/ActualiteMenu';
import ProgrammeMenu from './components/ProgramMenu';
import { UiBlog } from '../../../api/types';
import LoaderAndError from '../../../components/LoaderAndError';

interface Site {
    id?: number;
    nom?: string;
    description?: string;
    email?: string;
    adresse?: string;
    tel1?: string;
    tel2?: string;
    tel3?: string;
    token?: string;
    about?: string;
    mission?: string;
    objectif?: string;
    politique?: string;
    condition?: string;
    logo?: string;
    logoFile?: File;
    facebook?: string;
    linkedin?: string;
    twitter?: string;
    youtube?: string;
    whatsapp?: string;
    createdAt?: string;
    updatedAt?: string;
}

interface UiCatBlog {
    id?: number;
    titre?: string;
    slug?: string;
    createdAt?: string;
    updatedAt?: string;
}

interface UiSecteur {
    id?: number;
    nomSecteur?: string;
}
interface UiProject {
    id?: number;
    titre?: string;
    soustitre?: string;
    description?: string;
    idSecteur?: number;
    icone?: string;
    logoFile?: File;
    slug?: String;

    annee?: string;
    budget?: string;
    organisation?: string;

    createdAt?: string;
    updatedAt?: string;
    // jointire
    secteur_projet?: UiSecteur;

}



export default function NavBar() {
    // pour la langue
    const { t, i18n } = useTranslation();
    const changeLanguage = (lang: 'fr' | 'en') => {
        i18n.changeLanguage(lang);
    };

    // fin langue
    const [projects, setProject] = useState<UiProject[]>([]);
    const [sites, setSites] = useState<Site[]>([]);
    const [categories, setCategories] = useState<UiCatBlog[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    // États pour le menu mobile
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleDropdown = (dropdownName: string) => {
        setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<Site>('/fetch_data_site');
            setSites(res.data);
        } finally {
            setLoading(false);
        }
    }

    const fetchListCategorie = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiCatBlog>('/fetch_category_blog_data');
            setCategories(res.data);
        } finally {
            setLoading(false);
        }
    }

    const fetchListProjects = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiProject>('/fetch_projet_data');
            setProject(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }
    useEffect(() => {
        fetchData();
        fetchListCategorie();
        fetchListProjects();
    }, []);

    const { theme, toggleTheme } = useTheme();

    return (
        <div>
            {/* Header start*/}
            <header className="uc-header header-three uc-navbar-sticky-wrap z-999" data-uc-sticky="sel-target: .uc-navbar-container; cls-active: uc-navbar-sticky; cls-inactive: uc-navbar-transparent; end: !*;">
                <nav className="uc-navbar-container fs-6 z-1">
                    <div className="uc-center-navbar panel z-2 border-4 border-top border-primary bg-black uc-dark">
                        <div className="container max-w-2xl px-2 lg:px-4 xl:px-0">
                            <div className="uc-navbar items-center text-gray-900 dark:text-white" data-uc-navbar=" animation: uc-animation-slide-top-small; duration: 150;" style={{ height: "60px" }}>
                                <div className="uc-navbar-left gap-2 lg:gap-4">
                                    {/* Bouton hamburger pour mobile */}
                                    <button
                                        className="mobile-menu-trigger lg:d-none"
                                        onClick={toggleMobileMenu}
                                    >
                                        <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
                                    </button>

                                    <div className="uc-logo text-white">
                                        {sites.map((item, index) => (
                                            <Link to="/" key={index} className="h5 text-none text-gray-900 dark:text-white">
                                                <img className="w-80px text-dark dark:text-white" src={`${fileUrl}/images/${item.logo ?? 'avatar.png'}`} alt="Ouragan Academy" data-uc-svg />
                                            </Link>
                                        ))}
                                    </div>

                                    {/* Overlay pour mobile */}
                                    {isMobileMenuOpen && (
                                        <div
                                            className="mobile-menu-overlay active"
                                            onClick={closeMobileMenu}
                                        ></div>
                                    )}

                                    {/* Bouton de fermeture pour mobile */}
                                    {isMobileMenuOpen && (
                                        <button
                                            className="mobile-menu-close lg:d-none"
                                            onClick={closeMobileMenu}
                                        >
                                            <i className="fas fa-times"></i>
                                        </button>
                                    )}

                                    <ul
                                        className={`uc-navbar-nav gap-3 fs-5 fw-bolder ms-2 lg:d-flex ${isMobileMenuOpen ? 'mobile-open' : ''}`}
                                        id="hearder-comlique"
                                    >

                                        <li className={openDropdown === 'actualites' ? 'dropdown-open' : ''}>
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                toggleDropdown('actualites');
                                            }}>Actualités <span data-uc-navbar-parent-icon></span></a>
                                            <div className={`uc-navbar-dropdown ft-primary text-unset p-3 pb-4 hide-scrollbar ${openDropdown === 'actualites' ? 'dropdown-open' : ''}`}
                                                data-uc-drop=" offset: 0; boundary: !.uc-navbar; stretch: x; animation: uc-animation-slide-top-small; duration: 150;">
                                                <ActualiteMenu />
                                            </div>
                                        </li>


                                        <li className={openDropdown === 'programmes' ? 'dropdown-open' : ''}>
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                toggleDropdown('programmes');
                                            }}> Programmes <span data-uc-navbar-parent-icon></span></a>
                                            <div className={`uc-navbar-dropdown ft-primary text-unset p-3 pb-4 hide-scrollbar ${openDropdown === 'programmes' ? 'dropdown-open' : ''}`} data-uc-drop=" offset: 0; boundary: !.uc-navbar; stretch: x; animation: uc-animation-slide-top-small; duration: 150;">
                                                <ProgrammeMenu />
                                            </div>
                                        </li>

                                        <li>
                                            <Link to="/galery" onClick={closeMobileMenu}>Galerie</Link>
                                        </li>

                                        <li>
                                            <Link to="/don" onClick={closeMobileMenu}>Faire un don</Link>
                                        </li>

                                        <li>
                                            <Link to="/contact" onClick={closeMobileMenu}>Contact</Link>
                                        </li>



                                        <li className={openDropdown === 'plus' ? 'dropdown-open' : ''}>
                                            <a href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleDropdown('plus');
                                                }}>Plus <span data-uc-navbar-parent-icon></span></a>
                                            <div className={`uc-navbar-dropdown ft-primary text-unset p-3 hide-scrollbar ${openDropdown === 'plus' ? 'dropdown-open' : ''}`} data-uc-drop=" offset: 0; boundary: !.uc-navbar; stretch: x; animation: uc-animation-slide-top-small; duration: 150;">
                                                <div className="row child-cols g-4">
                                                    <div className='py-4'>
                                                        <div className="row child-cols g-4">
                                                            <div>
                                                                <ul className="uc-nav uc-navbar-dropdown-nav">
                                                                    <li className="uc-nav-header mb-1">L'Académie</li>
                                                                    <li><Link to="/about">Notre Histoire</Link></li>
                                                                    
                                                                    <li><Link to="/works">Ce que nous faisons</Link></li>
                                                                    <li><Link to="/team">Notre Équipe</Link></li>
                                                                    <li><Link to="#">Résultats</Link></li>
                                                                    <li><Link to="/faq">Faq</Link></li>

                                                                    <li><Link to="/structure-gestion">Structure de gestion</Link></li>
                                                                    <li><Link to="/partenariat-ship">Partenariat</Link></li>
                                                                    <li><Link to="/financement">Financement</Link></li>
                                                                    <li><Link to="/secteur">Secteur d'activité</Link></li>
                                                                </ul>
                                                            </div>
                                                            <div>
                                                                <ul className="uc-nav uc-navbar-dropdown-nav">
                                                                    <li className="uc-nav-header mb-1">Programmes</li>


                                                                    {
                                                                        projects.length === 0 ? (
                                                                            <LoaderAndError
                                                                                loading={loading}
                                                                                error={error}
                                                                                onClearError={() => setError(null)}
                                                                            />

                                                                        ) : (

                                                                            projects.map((item, index) => (

                                                                                <li key={index} ><Link to={`/project/${item.slug}`}>{item.titre}</Link></li>

                                                                            ))

                                                                        )
                                                                    }



                                                                </ul>
                                                            </div>
                                                            <div>
                                                                <ul className="uc-nav uc-navbar-dropdown-nav">
                                                                    <li className="uc-nav-header mb-1">Événements</li>
                                                                    <li><Link to="#">Tournois</Link></li>
                                                                    <li><Link to="#">Compétitions</Link></li>
                                                                    <li><Link to="#">Événements Spéciaux</Link></li>
                                                                    <li><Link to="#">Calendrier</Link></li>
                                                                    <li><Link to="/valeurs">Nos Valeurs</Link></li>
                                                                    <li><Link to="/services">Solutions</Link></li>
                                                                </ul>
                                                            </div>
                                                            <div>
                                                                <ul className="uc-nav uc-navbar-dropdown-nav">
                                                                    <li className="uc-nav-header mb-1">Informations</li>
                                                                    <li><Link to="/contact">Contact</Link></li>
                                                                    <li><Link to="/don">Faire un Don</Link></li>
                                                                    <li><Link to="/projects">Nos projets</Link></li>
                                                                    <li><Link to="/blogs">Presse</Link></li>
                                                                    <li><Link to="/realisations">Nos realisations</Link></li>
                                                                    <li><Link to="/galery">Galérie</Link></li>
                                                                    <li><Link to="/video">Vidéo</Link></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-3">
                                                        <div className="panel w-100 overflow-hidden">

                                                            <div className="ratio ratio-3x4 overflow-hidden rounded">
                                                                <VideoPub />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="uc-navbar-right gap-2 lg:gap-4">
                                    <a href={process.env.REACT_APP_ADMIN_URL} target='_blank' className="btn h-40px p-0 text-white border-0 lg:d-inline-flex">
                                        <i className="fas fa-sign-in-alt"></i>
                                        <span>Connexion</span>
                                    </a>
                                    <div className="vr h-16px my-auto"></div>
                                    <div className="uc-navbar-item d-none xl:d-inline-flex">
                                        {sites.map((item, index) => (
                                            <ul className="nav-x gap-2" key={index}>
                                                <li>
                                                    <a className="text-gray-900 dark:text-white hover:text-primary"
                                                        href={item.facebook} target="_blank"><i className="icon icon-1 fa-brands fa-facebook"></i></a>
                                                </li>
                                                <li>
                                                    <a className="text-gray-900 dark:text-white hover:text-primary"
                                                        href={item.twitter} target="_blank"><i className="icon icon-1 fa-brands fa-x-twitter"></i></a>
                                                </li>
                                                <li>
                                                    <a className="text-gray-900 dark:text-white hover:text-primary"
                                                        href={item.linkedin} target="_blank"><i className="icon icon-1 fa-brands fa-linkedin"></i></a>
                                                </li>
                                                <li>
                                                    <a className="text-gray-900 dark:text-white hover:text-primary"
                                                        href={item.youtube} target="_blank"><i className="icon icon-1 fa-brands fa-youtube"></i></a>
                                                </li>
                                            </ul>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
            {/* Header end*/}
        </div>
    )
}